<template>
  <div class="manghemadegood-order">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入订单编号/用户手机号..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.title"
                 clearable
                 placeholder="输入商品名称..."></Input>
        </FormItem>
        <!-- <FormItem>
            <Select
              v-model="formItem.good_type"
              :style="{'width':'150px'}"
              placeholder="选择来源..."
              clearable
            >
              <Option
                v-for="item in typeList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>-->
        <FormItem>
          <Select v-model="formItem.order_status"
                  :style="{'width':'150px'}"
                  placeholder="选择订单状态..."
                  clearable>
            <Option v-for="item in orderStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.ship_status"
                  :style="{'width':'150px'}"
                  placeholder="选择发货状态..."
                  clearable>
            <Option v-for="item in shipStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.receipt_status"
                  :style="{'width':'150px'}"
                  placeholder="选择收货状态..."
                  clearable>
            <Option v-for="item in recepitStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      @on-change="changeDate"
                      style="width: 260px"
                      placeholder="下单时间"></DatePicker>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      @on-change="changeApplyShipDate"
                      style="width: 260px"
                      placeholder="申请发货时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.pay_name"
                  clearable
                  filterable
                  placeholder="收单机构">
            <Option v-for="item in payNameList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>&nbsp;
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportOrder()">导出订单</Button>&nbsp;
          <Button type="success"
                  @click="showImportModel()">批量发货</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table max-height="600"
           border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <Form :model="detaildata"
            label-position="left"
            :label-width="100">
        <Row>
          <Col :xs="24"
               :md="24">
          <FormItem label="支付单号">
            <span>{{ detaildata.pay_order_num }}</span>
          </FormItem>
          <FormItem label="赠送人手机号">
            <span>{{ detaildata.zengsong_username }}</span>
          </FormItem>
          <FormItem label="订单编号">
            <span>{{ detaildata.order_num }}</span>
          </FormItem>
          <!-- <FormItem label="购买初级材料数量">
            <span>{{ detaildata.buy_lowdata_num }}</span>
          </FormItem>
          <FormItem label="购买高级材料数量">
            <span>{{ detaildata.buy_heighdata_num }}</span>
          </FormItem> -->
          <FormItem label="收件人">
            <span>{{ detaildata.person }}</span>
          </FormItem>
          <FormItem label="收件电话">
            <span>{{ detaildata.phone }}</span>
          </FormItem>
          <FormItem label="收件地址">
            <span>{{ detaildata.address }}</span>
          </FormItem>
          <FormItem label="快递名称">
            <span>{{ detaildata.logistics_name }}</span>
          </FormItem>
          <FormItem label="快递编号">
            <span>{{ detaildata.logistics_code }}</span>
          </FormItem>
          <FormItem label="融宝返回">
            <span>{{ detaildata.wxreturn_status }}</span>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :xs="24"
               :md="24">
          <Table border
                 stripe
                 :columns="columsgood"
                 :data="datagood"></Table>
          </Col>
        </Row>

      </Form>
    </Drawer>
    <!-- 详情弹层 end -->
    <!-- 发货弹框 -->
    <Modal v-model="showCreatTypeModal"
           title="发货"
           @on-ok="shipOrder('logisticValidate')"
           :loading="dataloading">
      <Form :model="shipdata"
            ref="logisticValidate"
            :rules="logisticValidate"
            action="javascript:void(0)">
        <FormItem label="请选择快递">
          <Select :label-in-value="true"
                  v-model="loginst"
                  @on-change="perChange"
                  clearable
                  filterable
                  placeholder="选择快递">
            <Option v-for="item in selectLogistics"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="快递单号"
                  prop="logistics_code">
          <Input v-model="shipdata.logistics_code"
                 placeholder />
        </FormItem>
        <FormItem label="商家备注"
                  prop="shop_mark">
          <Input v-model="shipdata.shop_mark"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
    <!-- 发货弹框 end -->
    <!-- 批量发货的弹出 -->
    <Modal v-model="showImportModalStatus"
           title="导入任务"
           @on-ok="importCar()"
           :loading="exportLoading">
      <Form :model="leadIn"
            action="javascript:void(0)">
        <FormItem label="选择文件">
          <!--<upload-question v-model="leadIn.filePath" :defaultList="fileListThree" ref="import-filesThree"></upload-question>-->
          <file-import v-model="leadIn.file_url"
                       :defaultList="fileListThree"
                       ref="import-filesThree"></file-import>
        </FormItem>
      </Form>
    </Modal>
    <!-- 快照弹层 start-->
    <Drawer width="50"
            v-model="modal2"
            title="快照详情"
            :mask-closable="false"
            @on-cancel="modal2 = false">
      <Form :model="detailphotodata"
            label-position="left"
            :label-width="100">
        <FormItem label="缩略图">
          <img :src="detailphotodata.thumb"
               style="width: 200px;height: 200px;" />
        </FormItem>
        <FormItem label="图集">
          <div class="upload-list"
               v-for="item in detailphotodata.album"
               :key="item">
            <img :src="item" />
          </div>
        </FormItem>
        <FormItem label="商品名称">
          <span>{{ detailphotodata.good_title }}</span>
        </FormItem>
        <FormItem label="规格名称">
          <span>{{ detailphotodata.good_spec_name }}</span>
        </FormItem>
        <FormItem label="品牌名称">
          <span>{{ detailphotodata.good_brand }}</span>
        </FormItem>
        <FormItem label="分类名称">
          <span>{{ detailphotodata.good_cate_title }}</span>
        </FormItem>
        <FormItem label="内容">
          <span v-html="detailphotodata.content"></span>
        </FormItem>
        <FormItem label="商品描述">
          <span v-html="detailphotodata.descript"></span>
        </FormItem>
      </Form>
    </Drawer>
    <!-- 快照弹层 end -->
  </div>
</template>

<script>
import FileImport from "../../common/fileimport";

export default {
  name: "manghemadegood-order",
  data () {
    return {
      typeList: [
        { value: 0, label: "盲盒订单" },
        { value: 1, label: "材料订单" }
      ],
      orderStatusList: [
        { value: 0, label: "正常" },
        { value: 1, label: "完成" },
        { value: 2, label: "回收" }
      ],
      payStatusList: [
        { value: 0, label: "未支付" },
        { value: 1, label: "支付中" },
        { value: 2, label: "支付完成" }
      ],
      shipStatusList: [
        { value: -1, label: "未申请" },
        { value: 0, label: "未发货" },
        { value: 1, label: "发货" }
      ],
      recepitStatusList: [
        { value: 0, label: "未确认收货" },
        { value: 1, label: "确认收货" }
      ],
      payNameList: [
        { id: 0, name: "融宝" },
        { id: 1, name: "财付通" },],
      detailphotodata: {},
      modal2: false,
      dataloading: true,
      selectLogistics: [],
      showCreatTypeModal: false,
      showImportModalStatus: false,
      fileListThree: [],
      leadIn: {},
      modal1: false,
      formItem: {
        key: "",
        phone: "",
        title: "",
        order_status: null,
        ship_status: null,
        receipt_status: null,
        type: 0,
        datetime: [],
        dateshiptime: []
      },
      loginst: [],
      shipdata: {
        name: "",
        code: ""
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        {
          title: "id",
          key: "id",
          width: 80
          // fixed:"left"
        },
        {
          title: "订单编号",
          width: 185,
          render: (h, params) => {
            return h("span", params.row.order_num);
          }
        },
        {
          title: "领取用户",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.user != null ? params.row.user.username : ""
            );
          }
        },
        {
          title: "来源",
          width: 100,
          align: "center",
          key: "good_type",
          render: (h, params) => {
            return h(
              "div",
              params.row.good_type == "0"
                ? "盲盒订单"
                : params.row.good_type == "1"
                  ? "材料订单"
                  : "赠送订单"
            );
          }
        },
        {
          title: "商品id",
          width: 80,
          key: "good_id"
        },
        {
          title: "商品名称",
          key: "title",
          width: 120
        },
        {
          title: "采购单价",
          width: 100,
          render: (h, params) => {
            return h("span", params.row.buy_price);
          }
        },
        {
          title: "支付金额",
          key: "total_prices",
          width: 100
        },
        {
          title: "收货人姓名",
          key: "person",
          width: 100,
          tooltip: true
        },
        {
          title: "收货人手机号",
          key: "phone",
          width: 120,
          tooltip: true
        },
        {
          title: "收货地址",
          key: "address",
          width: 200,
          tooltip: true
        },
        {
          title: "申请发货状态",
          width: 120,
          align: "center",
          render: (h, params) => {
            return h("div", params.row.is_ship == 0 ? "未申请" : "已申请");
          }
        },
        {
          title: "申请发货时间",
          key: "apply_ship_at",
          width: 150,
          align: "center"
        },
        {
          title: "商户发货状态",
          width: 100,
          align: "center",
          key: "ship_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.ship_status == "1" ? "geekblue" : "red"
                }
              },
              params.row.ship_status == "1" ? "已发货" : "未发货"
            );
          }
        },
        {
          title: "快递名称",
          key: "logistics_name",
          width: 100,
          tooltip: true
        },
        {
          title: "快递单号",
          key: "logistics_code",
          width: 150,
          tooltip: true
        },
        {
          title: "收货状态",
          width: 100,
          align: "center",
          key: "receipt_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.receipt_status == "1" ? "geekblue" : "red"
                }
              },
              params.row.receipt_status == "1" ? "已收货" : "未收货"
            );
          }
        },
        {
          title: "订单状态",
          width: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.order_status == "0"
                      ? "geekblue"
                      : params.row.order_status == "1"
                        ? "success"
                        : "orange"
                }
              },
              params.row.order_status == "0"
                ? "正常"
                : params.row.order_status == "1"
                  ? "完成"
                  : "回收"
            );
          }
        },
        {
          title: "下单时间",
          minWidth: 150,
          key: "created_at"
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 250,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              ),

              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.order_status == "0" &&
                        params.row.is_ship == "1" &&
                        params.row.ship_status == "0"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.ship(params.row.id);
                    }
                  }
                },
                "发货"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.is_orderphoto > 0
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.showOrderPhoto(params.row.id);
                    }
                  }
                },
                "订单快照"
              ),
            ]);
          }
        }
      ],
      detaildata: {},
      //订单详情
      columsgood: [
        {
          title: "商品名称",
          key: "goodtitle",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.goodtitle);
          }
        },
        {
          title: "材料",
          minWidth: 120,
          key: "price",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.hechengdata);
          }
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          width: 80,
          render: (h, params) => {
            return h("div", params.row.status == 2 ? "退回" : "正常");
          }
        }
      ],
      tablelist: [],
      datagood: [],
      logisticValidate: {
        logistics_code: [
          { required: true, message: "快递单号必须填写", trigger: "blur" }
        ],
        shop_mark: [
          { required: true, message: "商家备注必须填写", trigger: "blur" }
        ]
      },
      makedata: {
        status: 1
      },
      makedataValidate: {},
      exportLoading: false
    };
  },
  components: {
    FileImport
  },
  mounted: function () {
    // 取数据
    this.formItem.ship_status = this.$route.params.ship_status != -1 ? parseInt(this.$route.params.ship_status) : null;
    this.formItem.order_status = this.$route.params.order_status != -1 ? parseInt(this.$route.params.order_status) : null;
    this.getTableList();
    //取快递数据
    this.getLogisticList();
  },
  methods: {
    // 获取订单列表
    getTableList: function () {
      this.renderTable(1);
      return;
    },
    changeDate (val) {
      this.formItem.datetime = val;
    },
    changeApplyShipDate (val) {
      this.formItem.dateshiptime = val;
    },
    //获取快递列表
    getLogisticList () {
      var params = {
        page: 1,
        size: 10000
      };
      this.$api.logistics.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.selectLogistics = res.result.list;
        }
      });
    },
    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    ship: function (index) {
      this.id = index;
      this.showCreatTypeModal = true;
      this.shipdata = {};
      this.loginst = [];
    },
    cancelorder: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.madeorder.cancel({ id: index }).then(res => {
            if (res.code == 200) {
              this.renderTable(1);
            }
          });
        }
      });
    },
    perChange: function (index) {
      if (index == null || index == undefined) {
        return;
      }
      this.logistics_id = index.value;
      this.logistics_name = index.label;
    },
    shipOrder: function (name) {
      console.log("shipOrder");
      this.$refs[name].validate(valid => {
        console.log("shipOrder validate:", valid);
        if (valid) {
          console.log(valid);
          let params = {
            id: this.id,
            logistics_id: this.logistics_id,
            shop_mark: this.shipdata.shop_mark, // 备注
            logistics_name: this.logistics_name,
            logistics_code: this.shipdata.logistics_code // 快递单号
          };
          console.log(params);
          this.$api.mangheorder.goodsOrderShip(params).then(res => {
            if (res.code == 200) {
              this.showCreatTypeModal = false;
              this.getTableList();
            }
          });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.showCreatTypeModal = true;
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },

    // 查看详情
    detail: function (index) {
      this.modal1 = true;
      this.detaildata = {};
      var params = {
        id: index
      };
      this.$api.mangheorder.goodsOrderDetail(params).then(res => {
        if (res.code == 200) {
          this.datagood = res.result.productgood;
          this.detaildata = res.result;
        }
      });
      return;
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      var applyship_begin_at =
        this.formItem.dateshiptime[0] != undefined
          ? this.formItem.dateshiptime[0]
          : "";
      var applyship_end_at =
        this.formItem.dateshiptime[1] != undefined
          ? this.formItem.dateshiptime[1]
          : "";
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        good_name: this.formItem.title,
        order_status: this.formItem.order_status,
        ship_status: this.formItem.ship_status,
        receipt_status: this.formItem.receipt_status,
        good_type: 2,
        pay_name: this.formItem.pay_name,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at,
        applyship_begin_at: applyship_begin_at,
        applyship_end_at: applyship_end_at
      };
      this.$api.mangheorder.goodsOrderList(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          // for (var i = 0; i < 10; i++) {
          //   this.tablelist[i]._expanded = true;
          // }
          this.$Message.success(res.msg);
        }
      });
    },
    exportOrder () {
      this.exportLoading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      var applyship_begin_at =
        this.formItem.dateshiptime[0] != undefined
          ? this.formItem.dateshiptime[0]
          : "";
      var applyship_end_at =
        this.formItem.dateshiptime[1] != undefined
          ? this.formItem.dateshiptime[1]
          : "";
      this.$api.mangheorder
        .exportgoodorder({
          key: this.formItem.key,
          good_name: this.formItem.title,
          order_status: this.formItem.order_status,
          ship_status: this.formItem.ship_status,
          receipt_status: this.formItem.receipt_status,
          good_type: 2,
          pay_begin_at: pay_begin_at,
          pay_end_at: pay_end_at,
          applyship_begin_at: applyship_begin_at,
          pay_name: this.formItem.pay_name,
          applyship_end_at: applyship_end_at,
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
    // 导入
    showImportModel: function () {
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileListThree = [];
      this.leadIn.file_url = "";
    },
    // 查看订单快照详情
    showOrderPhoto: function (order_id) {
      this.modal2 = true;
      this.$api.mangheorder.photo({ order_id: order_id }).then(res => {
        if (res.code == 200) {
          this.detailphotodata = res.result;
          this.detailphotodata.album = res.result.album.split(',');
        }
      });
      return;
    },
    importCar (name) {
      if (
        this.$refs["import-filesThree"].resList != undefined &&
        this.$refs["import-filesThree"].resList.length
      ) {
        this.leadIn.file_url = this.$refs["import-filesThree"].resList[0].url;
      } else {
        this.leadIn.file_url = "";
        this.$Message.error("请选择上传文件");
        this.dataloading = false;
        this.$nextTick(() => {
          this.dataloading = true;
        });
        return;
      }
      this.$api.mangheorder.allShip(this.leadIn).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.showImportModalStatus = false;
        }
      });
    }
  }
};
</script>

<style scoped>
</style>